import { Plus } from 'lucide-react';
import React from 'react';
import { useEnv } from '../../components/providers/env-provider';
import { useUser } from '../../components/providers/user-provider';
import { Button } from '../../components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { SEND_PRODUCTION_APPROVAL_PERMISSIONS } from '@/config/feature-permissions';
import { hasPermission } from '@/utils/validation';
import { ListApproval } from './list-approval';

export function SendApproval() {
  const [openModal, setOpenModal] = React.useState(false);
  const { role } = useUser();
  const { env } = useEnv();

  if (!hasPermission(SEND_PRODUCTION_APPROVAL_PERMISSIONS[env], role)) {
    return null;
  }

  return (
    <Sheet open={openModal} onOpenChange={(open) => setOpenModal(open)}>
      <SheetTrigger asChild>
        <Button
          variant='default'
          className='gap-2 h-8 border-solid border-1 rounded p-4 border-slate-800'
          icon={<Plus className='h-4 w-4' />}
        >
          Send Production Approval
        </Button>
      </SheetTrigger>

      <SheetContent side={'bottom'}>
        <SheetHeader className='pb-4'>
          <SheetTitle>Send Production Approval</SheetTitle>
          <SheetDescription>
            Planners with changes in CTE will be displayed here. So MAKE sure
            your changes are in CTE before sending approval.
          </SheetDescription>
        </SheetHeader>
        <ListApproval setOpenModal={setOpenModal} />
      </SheetContent>
    </Sheet>
  );
}
